export default __webpack_public_path__ + "static/nav-banner-interest-free-271162f0f133fbef72fa4a48a42373d8.jpeg";